import ComponentManager from '@/Management/ComponentManager';
import { ISwitchViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';

import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import CheckBoxViewModel from '@/ViewModels/Controls/CheckBoxViewModel';

export default class SwitchViewModel extends CheckBoxViewModel {

    public image: ImageViewModel;

    public constructor(params: ISwitchViewModelConstructorParameter) {
        super(params);

        this.image = this.paramOrDefault(params.image, null);
    }
}

ComponentManager.setViewModel('SwitchViewModel', SwitchViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');